import DirectoryEditor from "./DirectoryEditor";

export default function Departments() {
  return (
    <DirectoryEditor
      resource="departments"
      title="Departments"
      eyebrow="Administration · Directory"
      description="Master list of departments used across Employees, Payroll and Assignments. Every renaming instantly rewires every employee."
    />
  );
}
